export default __webpack_public_path__ + "media/a2dee313ebcc424adba296d1b0f356660d4fbdb9c03a1118674c19835e3c80dd.svg";